/**
 * Build page numbers with ellipsis gaps for leaderboard pagination.
 * Example (15 pages, page 1): 1, 2, 3, …, 14, 15
 */
export function buildPaginationItems(currentPage, totalPages) {
  if (totalPages <= 1) return [];

  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => ({
      type: "page",
      page: index + 1,
      key: `page-${index + 1}`,
    }));
  }

  const pageSet = new Set([1, 2, 3, totalPages - 1, totalPages, currentPage]);
  if (currentPage > 1) pageSet.add(currentPage - 1);
  if (currentPage < totalPages) pageSet.add(currentPage + 1);

  const sorted = [...pageSet]
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((a, b) => a - b);

  const items = [];
  sorted.forEach((page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) {
      items.push({
        type: "ellipsis",
        key: `ellipsis-${sorted[index - 1]}-${page}`,
      });
    }
    items.push({ type: "page", page, key: `page-${page}` });
  });

  return items;
}
